var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"8D8EE3C2-8386-4638-8EF3-BB29A29E85BB"),React.createElement("g",{"id":"design","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"1440_materials","transform":"translate(-199.000000, -35.000000)"},React.createElement("g",{"id":"1440/topbar/state1-home"},[React.createElement("rect",{"id":"container","x":"0","y":"0","width":"1440","height":"80","key":0}),React.createElement("g",{"id":"ui/icons/plus/black","className":"fill-el","transform":"translate(199.000000, 35.000000)","fill":"#000000","key":1},React.createElement("path",{"d":"M6,-3.061617e-17 L6,5 L11,5 L11,6 L6,6 L6,11 L5,11 L5,6 L0,6 L0,5 L5,5 L5,3.061617e-17 L6,-3.061617e-17 Z","id":"ui/icons/plus"}))])))]);
}

Plus.defaultProps = {"width":"11px","height":"11px","viewBox":"0 0 11 11","version":"1.1"};

module.exports = Plus;

Plus.default = Plus;
